import { SVGProps } from 'react';

const EditNewIcon = (props: SVGProps<SVGSVGElement>) => {
  const { color = 'var(--brand-bg-primary)', className } = props;

  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      className={className}
      viewBox="0 0 10 10"
      data-palette="EditNewIcon">
      <g fill={color}>
        <path d="M6.113 1.765L.667 7.21c-.028.028-.048.062-.057.1L.006 9.734c-.018.073.004.15.057.203.04.04.095.063.151.063.017 0 .035-.002.052-.006L2.69 9.39c.038-.01.072-.03.1-.057l5.446-5.446-2.122-2.122zM9.71.845L9.149.282c-.375-.376-1.029-.376-1.403 0l-.687.69 1.963 1.97.688-.69c.187-.188.29-.438.29-.704 0-.266-.103-.515-.29-.703z" />
      </g>
    </svg>)
  );
};
export default EditNewIcon;
